<template>
    <MenuVue />
    <div class="detail-page">
        <div class="main-container" v-if="detail != null">
            <div class="video-container">
                <div class="video-wrap">
                    <div class="video-box">
                        <video id="hls-video" ref="video" class="video-js vjs-default-skin vjs-big-play-centered video" preload="auto" disablepictureinpicture disableremoteplayback controlslist="nodownload nofullscreen noremoteplayback noplaybackrate">
                            <!-- <source :src="detail.play_url" type="application/x-mpegURL" /> -->
                        </video>
                        <!-- <div class="video-poster" v-if="isplaying == false" @click="togglePlayer">
                            <div class="poster-bg">
                                <div class="play-icon"></div>
                            </div>
                        </div> -->
                    </div>

                    <div class="info-wrap">
                        <div class="left-con">
                            <div class="title">{{ detail.title }}</div>
                            <div class="user-num">{{ detail.user_count }} 学员</div>
                        </div>
                        <div class="right-con">
                            <div class="price-num" v-if="detail.is_buy == 0">￥{{ detail.price }}</div>
                            <div class="buttons">
                                <div class="abtn btn-buy" v-if="detail.is_buy == 0" @click="buyCourse">立即支付</div>
                                <div class="abtn btn-exchange" v-if="detail.is_buy == 0" @click="exchangeCourse">兑换课程</div>
                            </div>

                            <div class="info-text"  v-if="detail.is_buy == 1">使用AI工具平台请新开浏览器窗口，网址：<a target="_blank" href="https://ai.workeredu.cn/">https://ai.workeredu.cn/</a>，用户名:兑换手机号，初始密码:123456（请及时更改密码避免积分被盗用）</div>
                            <div class="buttons"  v-if="detail.is_buy == 1">
                                <div class="abtn btn-tools" @click="toAiTools">立即跳转</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="desc-container">
                <div class="desc-wrap">
                    <div class="head-tab">
                        <div v-if="showChapterCon" class="tab-item" :class="{ active: tabIndex == 0 }" @click="changeItem(0)">课程列表</div>
                        <div class="tab-item" :class="{ active: tabIndex == 1 }" @click="changeItem(1)">详情</div>
                    </div>
                    <div class="chapter-con" v-if="tabIndex == 0">
                        <div class="li" v-for="(item, idx) in detail.chapters" :key="idx" @click="playChapter(item)" :class="{ active: currChapter != null && currChapter.id == item.id }">{{ item.title }}</div>
                    </div>
                    <div class="desc-con" v-html="detail.content" v-if="tabIndex == 1"></div>
                </div>
            </div>
        </div>
    </div>
    <FooterVue />
    <RightFloat />
    <DialogTime5 v-if="visibleTime5" @click="dialogTime5Close" @exchange="onExchange" @buy="onBuy" />
    <DialogQrcodeVue v-if="visibleQrcode" @close="dialogQrcodeClose" />
    <ExchangeDialogVue v-if="exchangeDialog.visible" @close="exchangeDialogClose" :courseId="exchangeDialog.courseId" @success="onExchangeSuccess" />
    <AIRigisterResult v-if="aiRegister.visible" :data="aiRegister.data" @close="onHideRegisterResult" />
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import Hls from 'hls.js'

import { get, post } from '../utils/request'
import MenuVue from '../components/Menu.vue'
import FooterVue from '../components/Footer.vue'
import DialogQrcodeVue from '@/components/DialogQrcode.vue'
import ExchangeDialogVue from '@/components/ExchangeDialog.vue'
import DialogTime5 from '@/components/DialogTime5.vue'
import AIRigisterResult from '@/components/AIRigisterResult.vue'
import RightFloat from '@/components/RightFloat.vue'
import { duration } from 'videojs-contrib-hls/es5/playlist'

export default {
    components: { MenuVue, FooterVue, DialogTime5, DialogQrcodeVue, ExchangeDialogVue, AIRigisterResult, RightFloat },
    data() {
        return {
            player: null,
            visibleTime5: false,
            aiRegister: {
                visible: false,
                data: null
            },
            detail: null,
            id: 0,
            visibleQrcode: false,
            exchangeDialog: {
                visible: false,
                courseId: 0
            },
            isplaying: false,
            watchMaxTime: 120, // 最大看120秒
            tabIndex: 1,
            showChapterCon: false,
            currChapter: null,
            currPlayTime: null,
            prevPostTime: -10, // 上一次更新时间，间隔10秒提交一次
            firstTimeupdate: true
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    beforeUnmount() {
        console.log('beforeUnmount')
        if (this.player) {
            this.player.dispose()
            console.log('player dispose')
        }
    },
    created() {
        // if (!this.userInfo) {
        //     if (this.env == 'dev') {
        //         window.location.href = "http://test.workeredu.cn/login?back=%2Fai-course"
        //     } else {
        //         window.location.href = "https://workeredu.cn/login?back=%2Fai-course"
        //     }
        //     return;
        // }
        this.id = this.$route.query.id
        if (!this.id) {
            this.$router.replace('/')
            return false
        }
    },
    mounted() {
        this.loadDetail()
    },
    methods: {
        checkQueryType() {
            if (this.$route.query.type) {
                if (this.$route.query.type == 'exchange') {
                    this.exchangeCourse()
                } else if (this.$route.query.type == 'buy') {
                    this.buyCourse()
                }
            }
        },
        async loadDetail() {
            var res = await get('/course/detail', { id: this.id })
            // if (res.data.is_buy) {
            //     this.$router.replace('/jump?spu_id='+ res.data.spu_id);
            //     return
            // }
            this.detail = res.data
            if (this.detail.course_type == 2) {
                // 如果是系列课
                this.tabIndex = 0
                this.showChapterCon = true
            }
            await this.$nextTick()
            if (this.detail.course_type == 1) {
                if (this.detail.play_time_list.length > 0) {
                    this.currPlayTime = this.detail.play_time_list[0]
                    if (this.currPlayTime.duration > 0 && this.currPlayTime.duration - this.currPlayTime.curr_time < 3) {
                        this.currPlayTime.curr_time = 0
                    }
                } else {
                    this.currPlayTime = {
                        course_id: this.detail.id,
                        chapter_id: 0,
                        play_time: 0,
                        curr_time: 0,
                        is_finish: 0,
                        is_default: 1,
                        duration: 0
                    }
                }
                // 如果购买了
                if (this.detail.is_buy) {
                    this.initPlayer(this.detail.video_url, this.detail.img_url_compressed)
                } else {
                    this.initPlayer(this.detail.short_video_url, this.detail.img_url_compressed)
                }
            } else {
                // 如果购买了
                if (this.detail.is_buy) {
                    var defaultChapter = this.detail.play_time_list.find((it) => {
                        return it.is_default == 1
                    })
                    var nextChapter = null
                    if (!defaultChapter) {
                        for (var k in this.detail.chapters) {
                            defaultChapter = this.detail.play_time_list.find((it) => {
                                return it.chapter_id == this.detail.chapters[k].id
                            })
                            if (defaultChapter && defaultChapter.is_finish == 1) {
                                defaultChapter = null
                                continue
                            } else {
                                nextChapter = this.detail.chapters[k]
                                break
                            }
                        }
                    }
                    if (defaultChapter) {
                        nextChapter = this.detail.chapters.find((it) => {
                            return it.id == defaultChapter.chapter_id
                        })
                    }
                    if (nextChapter) {
                        this.currChapter = nextChapter
                    } else {
                        this.currChapter = this.detail.chapters[0]
                    }
                    this.currPlayTime = this.detail.play_time_list.find((it) => {
                        return it.course_id == this.detail.id && it.chapter_id == this.currChapter.id
                    })
                    if (this.currPlayTime == null) {
                        this.currPlayTime = {
                            course_id: this.detail.id,
                            chapter_id: this.currChapter.id,
                            play_time: 0,
                            curr_time: 0,
                            is_finish: 0,
                            is_default: 1,
                            duration: 0
                        }
                    } else {
                        if (this.currPlayTime.duration > 0 && this.currPlayTime.duration - this.currPlayTime.curr_time < 1) {
                            this.currPlayTime.curr_time = 0
                        }
                    }
                    this.initPlayer(this.currChapter.video_url, this.currChapter.img_url)
                } else {
                    this.currPlayTime = {
                        course_id: this.detail.id,
                        chapter_id: 0,
                        play_time: 0,
                        curr_time: 0,
                        is_finish: 0,
                        is_default: 1,
                        duration: 0
                    }
                    this.initPlayer(this.detail.short_video_url, this.detail.img_url_compressed)
                }
            }
            this.checkQueryType()
        },
        dialogTime5Close() {
            this.visibleTime5 = false
        },
        dialogTime5Show() {
            if (this.detail.is_buy == 0) {
                this.visibleTime5 = true
            } else {
                if (this.detail.course_type == 2) {
                    // 如果是序列课，并且当前已经读完，到下一个
                    for (var i = 0; i < this.detail.chapters.length; i++) {
                        if (this.detail.chapters[i].id == this.currChapter.id) {
                            if (i < this.detail.chapters.length - 1) {
                                this.playChapter(this.detail.chapters[i + 1])
                                break
                            }
                        }
                    }
                }
            }
        },
        exchangeCourse() {
            if (this.userInfo == null) {
                window.location.href = '/login?back=%2Fai-course'
            } else {
                this.exchangeDialog.visible = true
                this.exchangeDialog.courseId = this.id
            }
        },
        buyCourse() {
            this.visibleQrcode = true
        },
        dialogQrcodeClose() {
            this.visibleQrcode = false
        },
        onExchangeSuccess(data) {
            if (data) {
                this.aiRegister.data = data
                this.aiRegister.visible = true
            } else {
                this.loadDetail()
            }
        },
        initPlayer(src, poster) {
            if (this.player) {
                this.prevPostTime = -10
                this.firstTimeupdate = true
                this.player.src({ src: src, type: 'video/mp4' })
                this.player.poster(poster)
                this.player.load()
                this.player.play()
                return
            }
            var that = this
            var options = {
                autoplay: false,
                controls: true,
                sources: [],
                poster: poster,
                // 对于 HLS (m3u8)，建议启用 VHS（video.js 内置）
                html5: {
                    vhs: {
                        overrideNative: true // 强制使用内置 HLS 解析
                    }
                }
            }
            if (this.detail.is_buy) {
                // options.sources = [{ src: this.detail.play_url, type: 'application/x-mpegURL' }]
                options.sources = [{ src: src, type: 'video/mp4' }]
            } else {
                options.sources = [{ src: src, type: 'video/mp4' }]
            }
            this.player = videojs('hls-video', options, function onPlayerReady() {
                console.log('播放器已就绪')
            })
            this.player.on('error', (e) => {
                console.error('播放错误', e)
            })
            this.player.on('loadstart', (e) => {
                console.log('onLoadStartHandler', e)
                console.log(that.currPlayTime)
                this.isplaying = true
                this.player.currentTime(that.currPlayTime.curr_time)
            })
            this.player.on('loadedmetadata', (e) => {
                console.log('loadedmetadata', e)
            })
            this.player.on('seeking', (e) => {
                console.log('seeking:' + this.player.currentTime())
                var time = this.player.currentTime()
                that.prevPostTime = time
                // if (time > that.currPlayTime.play_time) {
                //     this.player.currentTime(that.currPlayTime.play_time)
                // }
            })
            this.player.on('error', (e) => {
                console.error('播放错误', e)
            })
            this.player.on('play', (e) => {
                // this.isplaying = true
            })
            this.player.on('pause', (e) => {
                // this.isplaying = false
            })
            // 开始实时监听播放进度
            this.player.on('timeupdate', () => {
                if (that.isplaying) {
                    if (that.detail.is_buy) {
                        console.log('timeupdate:' + this.player.currentTime())
                        const currentTime = this.player.currentTime()
                        const duration = this.player.duration()
                        if (currentTime - that.currPlayTime.curr_time > 2) {
                            if (currentTime > that.currPlayTime.play_time) {
                                this.player.currentTime(that.currPlayTime.play_time)
                                return
                            }
                        }
                        that.currPlayTime.curr_time = currentTime
                        that.currPlayTime.duration = duration
                        if (currentTime > that.currPlayTime.play_time) {
                            that.currPlayTime.play_time = currentTime
                        }
                        if (currentTime - that.prevPostTime >= 10) {
                            that.prevPostTime = currentTime
                            that.reportProgress()
                        }
                    }
                }
            })
            this.player.on('ended', (e) => {
                if (that.detail.is_buy) {
                    that.currPlayTime.is_finish = 1
                    that.reportProgress()
                }

                that.dialogTime5Show() // 提示购买
            })
        },
        playVideo() {
            this.player.play()
            this.isplaying = true
            console.log('play')
        },
        pauseVideo() {
            this.player.pause()
            this.isplaying = false
            console.log('pause')
        },
        seekTo(timeInSeconds) {
            this.player.currentTime(timeInSeconds)
        },
        togglePlayer() {
            if (this.isplaying == false) {
                this.playVideo()
            } else {
                this.pauseVideo()
            }
        },
        exchangeDialogClose() {
            this.exchangeDialog.visible = false
        },
        async reportProgress() {
            // 上报时间
            var res = await post('/course/savePlayTime', this.currPlayTime)
            console.log(res)
        },
        onExchange() {
            this.visibleTime5 = false
            this.exchangeCourse()
        },
        onBuy() {
            this.visibleTime5 = false
            this.buyCourse()
        },
        onHideRegisterResult() {
            this.loadDetail()
            this.aiRegister.visible = false
        },
        changeItem(idx) {
            this.tabIndex = idx
        },
        playChapter(item) {
            this.player.pause()
            this.isplaying = false
            if (this.detail.is_buy == 0) {
                // 如果没有购买，弹出支付
                this.buyCourse()
                return
            }
            this.currChapter = item
            this.currPlayTime = this.detail.play_time_list.find((it) => {
                return it.course_id == this.detail.id && it.chapter_id == this.currChapter.id
            })
            if (this.currPlayTime == null) {
                this.currPlayTime = {
                    course_id: this.detail.id,
                    chapter_id: this.currChapter.id,
                    play_time: 0,
                    curr_time: 0,
                    is_finish: 0,
                    is_default: 1,
                    duration: 0
                }
            } else {
                if (this.currPlayTime.duration > 0 && this.currPlayTime.duration - this.currPlayTime.curr_time < 1) {
                    this.currPlayTime.curr_time = 0
                }
            }
            this.initPlayer(this.currChapter.video_url, this.currChapter.img_url)
        },
        toAiTools(){
            window.open('https://ai.workeredu.cn/');
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 0.8;
$s750: 1;
.detail-page {
    line-height: 1.5;
    background-color: #eef0f2;
    min-height: 100vh;
    overflow: hidden;
    padding-top: 0.6rem;
    @media screen and (max-width: 1024px) {
        padding-top: (0.6rem * $s1024);
    }
    @media screen and (max-width: 750px) {
        padding-top: (0.8rem * $s750);
    }
    .main-container {
        .video-container {
            background-color: #43454c;
            @media screen and (max-width: 750px) {
                background-color: #f7f7f7;
            }
            .video-wrap {
                width: 11.2rem;
                height: 7.77rem;
                margin: 0 auto;
                position: relative;
                @media screen and (max-width: 1024px) {
                    width: (11.2rem * $s1024);
                    height: (7.77rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: 100%;
                    height: (7.82rem * $s750);
                }
                .video-box {
                    width: 11.2rem;
                    height: 6.33rem;
                    position: relative;
                    @media screen and (max-width: 1024px) {
                        width: (11.2rem * $s1024);
                        height: (6.33rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        width: 100%;
                        height: (4.78rem * $s750);
                    }
                    .video {
                        width: 11.2rem;
                        height: 6.33rem;
                        object-fit: contain;
                        background: #000;
                        @media screen and (max-width: 1024px) {
                            width: (11.2rem * $s1024);
                            height: (6.33rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            width: 100%;
                            height: (4.78rem * $s750);
                        }
                    }
                }
                .video-poster {
                    width: 11.2rem;
                    height: 6.33rem;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 4;
                    @media screen and (max-width: 1024px) {
                        width: (11.2rem * $s1024);
                        height: (6.33rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        width: 100%;
                        height: (4.78rem * $s750);
                    }
                    .poster-bg {
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.8);
                        position: relative;
                        cursor: pointer;
                        .play-icon {
                            width: 1.2rem;
                            height: 1.2rem;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            background: url(../assets/play.png) no-repeat center center;
                            background-size: contain;
                            &.pause {
                                background: url(../assets/pause.png) no-repeat center center;
                                background-size: contain;
                            }
                            @media screen and (max-width: 1024px) {
                                width: (1.2rem * $s1024);
                                height: (1.2rem * $s1024);
                            }
                            @media screen and (max-width: 750px) {
                                width: (1.2rem * $s750);
                                height: (1.2rem * $s750);
                            }
                        }
                    }
                }
                .info-wrap {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-content: center;
                    align-items: center;
                    height: 1.44rem;
                    color: #fff;
                    @media screen and (max-width: 1024px) {
                        height: (1.44rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        height: (3.06rem * $s750);
                        color: #0c1721;
                        flex-direction: column;
                        justify-content: center;
                        align-content: center;
                        align-items: flex-start;
                        padding: 0 0.4rem;
                    }
                    .left-con {
                        .title {
                            font-size: 0.28rem;
                            font-weight: bold;
                            margin-bottom: 0.1rem;
                            @media screen and (max-width: 1024px) {
                                font-size: (0.28rem * $s1024);
                                margin-bottom: (0.1rem * $s1024);
                            }
                            @media screen and (max-width: 750px) {
                                font-size: (0.36rem * $s750);
                                margin-bottom: (0.1rem * $s750);
                            }
                        }
                        .user-num {
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-content: center;
                            align-items: center;
                            font-size: 0.18rem;
                            @media screen and (max-width: 1024px) {
                                font-size: (0.18rem * $s1024);
                            }
                            @media screen and (max-width: 750px) {
                                font-size: (0.18rem * $s750);
                                color: #6f6e71;
                            }
                            &::before {
                                content: ' ';
                                display: block;
                                width: 0.2rem;
                                height: 0.2rem;
                                background: url(../assets/icon_user_white.png) no-repeat center center;
                                background-size: contain;
                                margin-right: 0.08rem;
                                @media screen and (max-width: 1024px) {
                                    width: (0.15rem * $s1024);
                                    height: (0.13rem * $s1024);
                                    margin-right: (0.08rem * $s1024);
                                }
                                @media screen and (max-width: 750px) {
                                    background: url(../assets/icon_user.png) no-repeat center center;
                                    background-size: contain;
                                    width: (0.2rem * $s750);
                                    height: (0.2rem * $s750);
                                    margin-right: (0.08rem * $s750);
                                }
                            }
                        }
                    }
                    .right-con {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-content: center;
                        align-items: center;
                        @media screen and (max-width: 750px) {
                            margin-top: 0.2rem;
                            justify-content: space-between;
                            width: 100%;
                        }
                        .price-num {
                            font-size: 0.44rem;
                            font-weight: bold;
                            padding-right: 0.2rem;
                            @media screen and (max-width: 1024px) {
                                font-size: (0.44rem * $s1024);
                                padding-right: (0.2rem * $s1024);
                            }
                            @media screen and (max-width: 750px) {
                                font-size: (0.62rem * $s750);
                                padding-right: (0.2rem * $s750);
                                color: #eb2234;
                            }
                        }
                        .info-text {
                            width: 3.8rem;
                            margin-right: 0.4rem;
                            font-size: 0.14rem;
                            line-height: 2;
                            word-break: break-all;
                            white-space: break-spaces;
                            color: #fff;
                            @media screen and (max-width: 1024px) {
                            }
                            @media screen and (max-width: 750px) {
                                width: (6rem * $s750);
                                font-size: (0.18rem * $s750);
                                padding-right: (0rem * $s750);
                                color: #000;
                                line-height: 1.5;
                            }
                            a {
                                color: #fff;
                                @media screen and (max-width: 1024px) {
                                }
                                @media screen and (max-width: 750px) {
                                    color: #000;
                                }
                            }
                        }
                        .buttons {
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-content: center;
                            align-items: center;
                            .abtn {
                                width: 1.02rem;
                                height: 0.36rem;
                                font-size: 0.16rem;
                                justify-content: center;
                                align-content: center;
                                align-items: center;
                                display: flex;
                                margin-left: 0.1rem;
                                border-radius: 0.04rem;
                                cursor: pointer;
                                @media screen and (max-width: 1024px) {
                                    width: (1.02rem * $s1024);
                                    height: (0.36rem * $s1024);
                                    font-size: (0.16rem * $s1024);
                                    margin-left: (0.1rem * $s1024);
                                    border-radius: (0.04rem * $s1024);
                                }
                                @media screen and (max-width: 750px) {
                                    width: (1.4rem * $s750);
                                    height: (0.7rem * $s750);
                                    font-size: (0.24rem * $s750);
                                    margin-left: (0.1rem * $s750);
                                    border-radius: (0.04rem * $s750);
                                }

                                &.btn-exchange {
                                    border: 1px solid #fff;
                                    color: #fff;
                                    @media screen and (max-width: 750px) {
                                        border: 1px solid #eb2234;
                                        background: transparent;
                                        color: #eb2234;
                                    }
                                }
                                &.btn-buy {
                                    border: 1px solid #eb2234;
                                    background: #eb2234;
                                    @media screen and (max-width: 750px) {
                                        border: 1px solid #eb2234;
                                        background: eb2234;
                                        color: #fff;
                                    }
                                }
                                &.btn-tools {
                                    border: 1px solid #eb2234;
                                    background: #eb2234;
                                    @media screen and (max-width: 750px) {
                                        border: 1px solid #eb2234;
                                        background: eb2234;
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .desc-container {
            background-color: #eef0f2;
            .desc-wrap {
                width: 11.2rem;
                margin: 0 auto;
                background-color: #fff;
                @media screen and (max-width: 1024px) {
                    width: (11.2rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: 100%;
                }
                .head-tab {
                    height: 0.45rem;
                    border-bottom: 1px solid #f2f4f5;
                    padding: 0 0.2rem;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    @media screen and (max-width: 1024px) {
                        height: (0.45rem * $s1024);
                        padding: 0 (0.2rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        height: (0.6rem * $s750);
                        padding: 0 (0.4rem * $s750);
                    }
                    .tab-item {
                        font-size: 0.16rem;
                        color: #000;
                        line-height: 0.45rem;
                        border-bottom: 1px solid transparent;
                        cursor: pointer;
                        margin-right: 0.2rem;
                        width: 0.7rem;
                        text-align: center;
                        &:hover {
                            color: #eb2234;
                            border-bottom: 1px solid #eb2234;
                        }
                        @media screen and (max-width: 1024px) {
                            font-size: (0.16rem * $s1024);
                            line-height: (0.45rem * $s1024);
                            margin-right: (0.2rem * $s1024);
                            width: (0.7rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            font-size: (0.22rem * $s750);
                            line-height: (0.6rem * $s750);
                            margin-right: (0.2rem * $s750);
                            width: (1.14rem * $s750);
                        }
                        &.active {
                            color: #eb2234;
                            border-bottom: 1px solid #eb2234;
                        }
                    }
                }
                .chapter-con {
                    padding: 0rem 0rem 0.4rem 0rem;
                    @media screen and (max-width: 1024px) {
                        padding: 0rem 0rem (0.4rem * $s1024) 0rem;
                    }
                    @media screen and (max-width: 750px) {
                        padding: 0rem 0rem (0.4rem * $s750) 0rem;
                    }
                    .li {
                        font-size: 0.16rem;
                        color: #333;
                        line-height: 0.45rem;
                        border-bottom: 1px solid #f2f4f5;
                        padding: 0 0.4rem;
                        cursor: pointer;
                        @media screen and (max-width: 1024px) {
                            font-size: (0.16rem * $s1024);
                            line-height: (0.45rem * $s1024);
                            padding: 0 (0.4rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            font-size: (0.2rem * $s750);
                            line-height: (0.55rem * $s750);
                            padding: 0 (0.4rem * $s750);
                        }
                        &:last-child {
                            border-bottom: 1px solid transparent;
                        }
                        &:hover,
                        &.active {
                            color: #eb2234;
                        }
                    }
                }
                .desc-con {
                    font-size: 0.17rem;
                    color: #666463;
                    padding: 0.15rem 0.4rem 0.4rem 0.4rem;
                    min-height: 2rem;
                    :deep(p) {
                        font-size: 0.17rem;
                        line-height: 1.8;
                        margin: 0 !important;
                        padding: 0 !important;
                        margin-bottom: 0.1rem !important;
                        @media screen and (max-width: 1024px) {
                            font-size: (0.17rem * $s1024);
                        }
                        @media screen and (max-width: 750px) {
                            font-size: (0.28rem * $s750);
                        }
                    }
                    @media screen and (max-width: 1024px) {
                        font-size: (0.17rem * $s1024);
                        padding: (0.15rem * $s1024) (0.4rem * $s1024) (0.4rem * $s1024) (0.4rem * $s1024);
                        min-height: (2rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        font-size: (0.28rem * $s750);
                        padding: (0.25rem * $s750) (0.4rem * $s750) (0.8rem * $s750) (0.4rem * $s750);
                        min-height: (2rem * $s750);
                    }
                }
            }
        }
    }
}
</style>
